import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configProvider/delete/uptime.configProvider.delete.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigProviderDeleteMutation,
  UptimeConfigProviderDeleteMutationVariables,
} from "@/v2-backoffice-client/uptime/configProvider/delete/__types__/uptime.configProvider.delete.mutation"

type Options = MutationHookOptions<
  UptimeConfigProviderDeleteMutation,
  UptimeConfigProviderDeleteMutationVariables
>

export function useUptimeConfigProviderDeleteMutation(options?: Options) {
  return useMutation<
    UptimeConfigProviderDeleteMutation,
    UptimeConfigProviderDeleteMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
